"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sticky = exports.staticPosition = exports.relative = exports.fixed = exports.absolute = void 0;
require("./position.css");
// static is a reserved word
const staticPosition = "cds-staticPosition-si6ru8l";
exports.staticPosition = staticPosition;
const relative = "cds-relative-r1fxlug";
exports.relative = relative;
const fixed = "cds-fixed-f1v5p9l4";
exports.fixed = fixed;
const absolute = "cds-absolute-aifrgod";
exports.absolute = absolute;
const sticky = "cds-sticky-s137m7e3";
exports.sticky = sticky;